import React, { Component, useState, useRef } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./CustomModules.scss";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Menu, MenuItem, Modal } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CheckBox from "../../../../Supporting files/CheckBox/CheckBox";
import SettingPopup from "./CustomModulePopups/SettingPopup";
import AddNewSectionPopup from "./CustomModulePopups/AddNewSectionPopup";
// import MultiLineProperties from "./CustomModulePopups/MultiLineProperties";
// import CurrencyProperties from "./CustomModulePopups/CurrencyProperties";
// import CheckboxProperties from "./CustomModulePopups/CheckboxProperties";
// import ContactProperties from "./CustomModulePopups/ContactProperties";
// import PicklistProperties from "./CustomModulePopups/PicklistProperties";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import SingleLineProperties from "./CustomModulePopups/SingleLineProperties";
// import EmailProperties from "./CustomModulePopups/EmailProperties";
// import DateProperties from "./CustomModulePopups/DateProperties";
// import MultiSelectProperties from "./CustomModulePopups/MultiSelectProperties";
// import NumberProperties from "./CustomModulePopups/NumberProperties";
// import URLProperties from "./CustomModulePopups/URLProperties";
// import SearchSelectProperties from "./CustomModulePopups/SearchSelectProperties";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PreviewPage from "../../../../Components/Broker/PreviewPage/PreviewPage";
import DeletePopup from "../../../../Components/Common/DeletePopup/DeletePopup";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const moduleList_data = [
  { key: "Quotes", value: "Quotes" },
  { key: "Policies", value: "Policies" },
  { key: "Policy Renewal", value: "Policy Renewal" },
  { key: "Clients", value: "Clients" },
  { key: "Contacts", value: "Contacts" },
  { key: "Employees", value: "Employees" },
  { key: "Endorsement", value: "Endorsement" },
  { key: "Claim", value: "Claim" },
];
// let navigate = useNavigate();
const stage_table_data = [
  {
    heading_name: "Sourcing",
  },
  {
    heading_name: "Rejected - Screening",
  },
];

const innertable_data = [
  {
    innertable_name: "New",
  },
  {
    innertable_name: "Associate",
  },
];

export default class CustomModules extends Component {
  updateMasterState = (attrName, value) => {
    //attrName(value);
    if (attrName === "settingPopup") {
      this.setState({ settingPopup: value });
    } else if (attrName === "picklistProperties") {
      this.setState({ picklistProperties: value });
    } else if (attrName === "multiLineProperties") {
      this.setState({ multiLineProperties: value });
    } else if (attrName === "currencyProperties") {
      this.setState({ currencyProperties: value });
    } else if (attrName === "checkboxProperties") {
      this.setState({ checkboxProperties: value });
    } else if (attrName === "contactProperties") {
      this.setState({ contactProperties: value });
    } else if (attrName === "addNewSectionPopup") {
      this.setState({ addNewSectionPopup: value });
    } else if (attrName === "singleLineProperties") {
      this.setState({ singleLineProperties: value });
    } else if (attrName === "emailProperties") {
      this.setState({ emailProperties: value });
    } else if (attrName === "dateProperties") {
      this.setState({ dateProperties: value });
    } else if (attrName === "multiselectProperties") {
      this.setState({ multiselectProperties: value });
    } else if (attrName === "numberProperties") {
      this.setState({ numberProperties: value });
    } else if (attrName === "urlProperties") {
      this.setState({ urlProperties: value });
    } else if (attrName === "searchselectProperties") {
      this.setState({ searchselectProperties: value });

      if (this.state.newSectionName.toString().length > 0) {
        this.setState({
          sections: [
            ...this.state.sections,
            { section_name: this.state.newSectionName, fields: [] },
          ],
        });
      }
    } else if (attrName === "newSectionName") {
      this.setState({ newSectionName: value });
    } else if (attrName === "previewStatus") {
      this.setState({ previewStatus: value });
    } else if (attrName === "deletePopup") {
      this.setState({ deletePopup: value });
    } else {
      this.setState({ [attrName]: value });
    }
    console.log(attrName, value);
  };

  //open = Boolean(this.state.settingDropdown);
  openSetting = (event) => {
    //this.setState({ settingDropdown: event.currentTarget });
  };

  closeSetting = () => {
    this.setState({ settingDropdown: null });
  };

  state = {
    previewStatus: false,
    addStage: false,
    stageName: "",
    chooseColor: "",
    addstatus: false,
    deleteStatus: false,
    deleteStatusStep: 1,
    statusName: "",
    table_data: [
      {
        title: "Sourcing",
        open_status: false,
        data: [{ name: "New" }, { name: "Assosciate" }],
      },
      {
        title: "Rejected",
        open_status: false,
        data: [
          { name: "Over Experirnced" },
          { name: "Less Experienced" },
          { name: "Out of budget" },
        ],
      },
    ],
    settingPopup: false,
    addNewSectionPopup: false,
    newSectionName: "",
    items: [
      {
        id: "0",
        title: "Single Line",
        field_type: "single_line",
        class_name: "singleline",
        grid: 6,
      },
      {
        id: "1",
        title: "Multi Line",
        field_type: "multi_line",
        class_name: "multiline",
        grid: 6,
      },
      {
        id: "2",
        title: "Phone",
        field_type: "phone",
        class_name: "phone",
        grid: 6,
      },
      {
        id: "3",
        title: "email",
        field_type: "text_input",
        class_name: "email",
        grid: 6,
      },
      {
        id: "4",
        title: "Single Select",
        field_type: "dropdown",
        class_name: "singleselect",
        grid: 6,
      },
      {
        id: "5",
        title: "Multi Select",
        field_type: "searchable_dropdown",
        class_name: "multiselect",
        grid: 6,
      },
      {
        id: "5",
        title: "Search Select",
        field_type: "searchable_dropdown",
        class_name: "searchselect",
        grid: 6,
      },
      {
        id: "6",
        title: "Date Picker",
        field_type: "date_picker",
        class_name: "datepicker",
        grid: 6,
      },
      {
        id: "7",
        title: "Number",
        field_type: "text_input",
        class_name: "number",
        grid: 6,
      },
      {
        id: "8",
        title: "Currency",
        field_type: "text_input",
        class_name: "currency",
        grid: 6,
      },
      {
        id: "9",
        title: "Checkbox",
        field_type: "checkbox",
        class_name: "checkbox",
        grid: 6,
      },
      {
        id: "9",
        title: "Radio",
        field_type: "radio",
        class_name: "radio",
        grid: 6,
      },
      {
        id: "10",
        title: "URL",
        field_type: "text_input",
        class_name: "url",
        grid: 6,
      },
      {
        id: "11",
        title: "Address",
        field_type: "text_input",
        class_name: "address",
        grid: 6,
      },
    ],
    fields_data: [
      {
        srno: "0",
        fieldname: "City",
        datatype: "single_line",
        module: "Policy",
        checkbox_status: false,
      },
      {
        srno: "1",
        fieldname: "Country",
        datatype: "single_line",
        module: "Policy",
        checkbox_status: false,
      },
      {
        srno: "2",
        fieldname: "Data Closed",
        datatype: "single_line",
        module: "Policy",
        checkbox_status: false,
      },
      {
        srno: "3",
        fieldname: "Policy Number",
        datatype: "single_line",
        module: "Policy",
        checkbox_status: false,
      },
      {
        srno: "4",
        fieldname: "Client ID",
        datatype: "single_line",
        module: "Policy",
        checkbox_status: false,
      },
    ],
    selected: [
      {
        id: "ABCDDFER",
        title: "Single Line",
        field_type: "single_line",
        class_name: "singleline",
      },
    ],
    sections: [
      {
        section_name: "Basic Info",
        fields: [
          {
            id: "CD002",
            title: "Single Line",
            field_type: "single_line",
            class_name: "singleline",
            grid: { sm: 5, md: 5, lg: 5 },
          },
          {
            id: "CD003",
            title: "Single Line",
            field_type: "single_line",
            class_name: "singleline",
            grid: { sm: 5, md: 5, lg: 5 },
          },
          {
            id: "CD001",
            title: "Single Select",
            field_type: "dropdown",
            class_name: "dropdown",
            grid: { sm: 3, md: 3, lg: 3 },
          },
          {
            id: "CD004",
            title: "Date Picker",
            field_type: "date_picker",
            class_name: "datepicker",
            grid: { sm: 3, md: 3, lg: 3 },
          },
          {
            id: "CD005",
            title: "Number",
            field_type: "number",
            class_name: "number",
            grid: { sm: 3, md: 3, lg: 3 },
          },
          {
            id: "CD006",
            title: "Email",
            field_type: "text_input",
            class_name: "email",
            grid: { sm: 5, md: 5, lg: 5 },
          },
        ],
      },
      {
        section_name: "Professional Details",
        fields: [
          {
            id: "PD001",
            title: "Office Phone",
            field_type: "number",
            class_name: "number",
            grid: { sm: 5, md: 5, lg: 5 },
          },
          {
            id: "PD002",
            title: "Office Email",
            field_type: "text_input",
            class_name: "email",
            grid: { sm: 5, md: 5, lg: 5 },
          },
          {
            id: "PD003",
            title: "Department",
            field_type: "single_line",
            class_name: "singleline",
            grid: { sm: 5, md: 5, lg: 5 },
          },
          {
            id: "PD004",
            title: "Designation",
            field_type: "single_line",
            class_name: "singleline",
            grid: { sm: 5, md: 5, lg: 5 },
          },
        ],
      },
      {
        section_name: "Personal Address",
        fields: [
          {
            id: "PFD001",
            title: "Building/Street name",
            field_type: "single_line",
            class_name: "singleline",
            grid: { sm: 5, md: 5, lg: 5 },
          },
          {
            id: "PFD002",
            title: "Area name",
            field_type: "single_line",
            class_name: "singleline",
            grid: { sm: 5, md: 5, lg: 5 },
          },
          {
            id: "PFD003",
            title: "Country",
            field_type: "dropdown",
            class_name: "dropdown",
            grid: { sm: 3, md: 3, lg: 3 },
          },

          {
            id: "PFD004",
            title: "State",
            field_type: "dropdown",
            class_name: "dropdown",
            grid: { sm: 3, md: 3, lg: 3 },
          },
          {
            id: "PFD005",
            title: "City",
            field_type: "dropdown",
            class_name: "dropdown",
            grid: { sm: 3, md: 3, lg: 3 },
          },
          {
            id: "PFD006",
            title: "Country",
            field_type: "number",
            class_name: "number",
            grid: { sm: 3, md: 3, lg: 3 },
          },
        ],
      },
      {
        section_name: "Organization Info",
        fields: [
          {
            id: "OD001",
            title: "Organization",
            field_type: "single_line",
            class_name: "singleline",
            grid: { sm: 7, md: 7, lg: 7 },
          },
          {
            id: "PFD002",
            title: "Industry",
            field_type: "dropdown",
            class_name: "dropdown",
            grid: { sm: 6, md: 6, lg: 6 },
          },
          {
            id: "PFD003",
            title: "Sub-Industry",
            field_type: "dropdown",
            class_name: "dropdown",
            grid: { sm: 6, md: 6, lg: 6 },
          },
        ],
      },
      {
        section_name: "Office Address",
        fields: [
          {
            id: "PFD001",
            title: "Building/Street name",
            field_type: "single_line",
            class_name: "singleline",
            grid: { sm: 5, md: 5, lg: 5 },
          },
          {
            id: "PFD002",
            title: "Area name",
            field_type: "single_line",
            class_name: "singleline",
            grid: { sm: 5, md: 5, lg: 5 },
          },
          {
            id: "PFD003",
            title: "Country",
            field_type: "dropdown",
            class_name: "dropdown",
            grid: { sm: 3, md: 3, lg: 3 },
          },

          {
            id: "PFD004",
            title: "State",
            field_type: "dropdown",
            class_name: "dropdown",
            grid: { sm: 3, md: 3, lg: 3 },
          },
          {
            id: "PFD005",
            title: "City",
            field_type: "dropdown",
            class_name: "dropdown",
            grid: { sm: 3, md: 3, lg: 3 },
          },
          {
            id: "PFD006",
            title: "Country",
            field_type: "number",
            class_name: "number",
            grid: { sm: 3, md: 3, lg: 3 },
          },
        ],
      },
    ],
    productTabsStatus: "Layout",
    moduleList: "",
    toggleLock: true,
    fieldcheckbox: true,
    settingDropdown: null,
  };

  id2List = {
    droppable: "items",
    droppable2: "selected",
  };

  getList = (id) => this.state[this.id2List[id]];

  onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      const items = reorder(
        this.getList(source.droppableId),
        source.index,
        destination.index
      );
      let state = { items };

      if (source.droppableId === destination.droppableId) {
        state = { selected: items };
      }
      this.setState(state);
    } else {
      let data = this.state.sections;
      let select_data = this.state.items[source.index];
      data[parseInt(destination.droppableId)].fields = [
        ...data[parseInt(destination.droppableId)].fields,
        {
          id: Math.random(),
          title: select_data.title,
          field_type: select_data.field_type,
          class_name: select_data.class_name,
          grid: select_data.grid,
        },
      ];

      this.setState({
        sections: data,
      });
    }
  };

  delete_fields = (index, sub_index) => {
    let data = this.state.sections;

    data[index].fields.splice(sub_index, 1);

    this.setState({ sections: data });
  };
  // onSubmit = () => {
  //   return <Redirect to="/SettingModuleForm/" />;
  // };
  render() {
    return (
      <Box className="customModuleWrapper">
        <PreviewPage
          open_status={this.state.previewStatus}
          attrName="previewStatus"
          value_update={this.updateMasterState}
        />
        <SettingPopup
          open_status={this.state.settingPopup}
          attrName="settingPopup"
          value_update={this.updateMasterState}
        />
        <DeletePopup
          open_status={this.state.deletePopup}
          attrName={"deletePopup"}
          value_update={this.updateMasterState}
          p1={
            <>
              Are you sure you want{" "}
              <>
                <br />
              </>{" "}
              to delete "Associate" status?
            </>
          }
          p2={"You are about to delete 1 status"}
          p3={"Your status has been deleted"}
        />
        {/*
        <SearchSelectProperties
          open_status={true}
          attrName="searchselectProperties"
          value_update={this.updateMasterState}
        />
       
        <URLProperties
          open_status={this.state.urlProperties}
          attrName="urlProperties"
          value_update={this.updateMasterState}
        />
     
        <NumberProperties
          open_status={this.state.numberProperties}
          attrName="numberProperties"
          value_update={this.updateMasterState}
        />
        
        <PicklistProperties
          open_status={this.state.picklistProperties}
          attrName="picklistProperties"
          value_update={this.updateMasterState}
        />
        <MultiSelectProperties
          open_status={this.state.multiselectProperties}
          attrName="multiselectProperties"
          value_update={this.updateMasterState}
        />
       
        <DateProperties
          open_status={this.state.dateProperties}
          attrName="dateProperties"
          value_update={this.updateMasterState}
        />
        <EmailProperties
          open_status={this.state.emailProperties}
          attrName="emailProperties"
          value_update={this.updateMasterState}
        />
       <SingleLineProperties
          open_status={this.state.singleLineProperties}
          attrName="singleLineProperties"
          value_update={this.updateMasterState}
        /> 
        
        <MultiLineProperties
          open_status={this.state.multiLineProperties}
          attrName="multiLineProperties"
          value_update={this.updateMasterState}
        />
       
        <CurrencyProperties
          open_status={this.state.currencyProperties}
          attrName="currencyProperties"
          value_update={this.updateMasterState}
        />
        <CheckboxProperties
          open_status={this.state.checkboxProperties}
          attrName="checkboxProperties"
          value_update={this.updateMasterState}
        />
        <ContactProperties
          open_status={this.state.contactProperties}
          attrName="contactProperties"
          value_update={this.updateMasterState}
        /> */}
        <AddNewSectionPopup
          open_status={this.state.addNewSectionPopup}
          attrName="addNewSectionPopup"
          section_name={this.state.newSectionName}
          section_name_attrName={"newSectionName"}
          value_update={this.updateMasterState}
        />
        <Grid container spacing={3} alignSelf={"center"}>
          <Grid xs={12} className="custom_layout_header">
            <h3 className="pageTitle">
              <Link
                onClick={() => {
                  window.location.href = "/homebroker";
                }}
              >
                <ChevronLeftIcon />
              </Link>
              Modules
              <SelectDropdown
                class_name="inputField ml-6"
                title="Select Module"
                value={this.state.moduleList}
                attrName={"moduleList"}
                value_update={this.updateMasterState}
                dropdown_data={moduleList_data}
                warn_status={false}
              />
            </h3>
            <Button
              className="privew_button"
              onClick={() => {
                console.log("sdfdrsgcx");
                this.setState({ previewStatus: true });
              }}
            >
              <VisibilityIcon /> Preview
            </Button>
          </Grid>

          <Grid xs={8}>
            <div className="productTabs">
              <Button
                className={
                  this.state.productTabsStatus == "Layout"
                    ? "defaultTab active"
                    : "defaultTab"
                }
                onClick={() => {
                  this.setState({ productTabsStatus: "Layout" });
                }}
              >
                Layout
              </Button>
              <Button
                className={
                  this.state.productTabsStatus == "Fields"
                    ? "defaultTab active"
                    : "defaultTab"
                }
                onClick={() => {
                  this.setState({ productTabsStatus: "Fields" });
                }}
              >
                Fields
              </Button>
              <Button
                className={
                  this.state.productTabsStatus == "Summary"
                    ? "defaultTab active"
                    : "defaultTab"
                }
                onClick={() => {
                  this.setState({ productTabsStatus: "Summary" });
                }}
              >
                Summary
              </Button>
              <Button
                className={
                  this.state.productTabsStatus == "Stages"
                    ? "defaultTab active"
                    : "defaultTab"
                }
                onClick={() => {
                  this.setState({ productTabsStatus: "Stages" });
                }}
              >
                Stages & Status
              </Button>
            </div>
          </Grid>
          <Grid xs={4} style={{ textAlign: "right" }}>
            {this.state.productTabsStatus == "Layout" ? (
              <Link
                underline="none"
                className="blueBtn addfile"
                onClick={() => {
                  this.setState({
                    newSectionName: "",
                    addNewSectionPopup: true,
                  });
                }}
              >
                Add New Section
              </Link>
            ) : null}
            {this.state.productTabsStatus == "Stages" ? (
              <>
                {/* <Link
                  
                  underline="none"
                  className="blackBtn settings"
                   onClick={() => setUploadFile(true)}
                >
                  Filter
                </Link> */}
                <Link
                  underline="none"
                  className="greenBtn addfile"
                  onClick={() => {
                    this.setState({
                      addStage: true,
                    });
                  }}
                >
                  Add Stages
                </Link>
              </>
            ) : null}
          </Grid>

          {/* Layout of selected Module */}
          {this.state.productTabsStatus == "Layout" ? (
            <>
              <DragDropContext onDragEnd={this.onDragEnd}>
                <Grid xs className="fieldsSection">
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <Box className="innerPart" ref={provided.innerRef}>
                        <h5>
                          <DashboardCustomizeIcon /> New Fields
                        </h5>
                        <ul>
                          {this.state.items.map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <li
                                  className={item.class_name}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  {item.title}
                                </li>
                              )}
                            </Draggable>
                          ))}
                        </ul>
                        {provided.placeholder}
                      </Box>
                    )}
                  </Droppable>
                </Grid>
                <Grid xs className="layoutSection">
                  <Box className="innerPart">
                    <Grid container spacing={0} sx={{ padding: "0" }}>
                      <Grid xs={12} className="sectionTitle">
                        <h5>Personal Details</h5>
                        <div className="actionBtns">
                          <Link
                            className="delete_btn"
                            sx={{
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                          >
                            <DeleteForeverIcon />
                            Remove
                          </Link>
                        </div>
                      </Grid>
                    </Grid>

                    {this.state.sections.map((item, index) => (
                      <section>
                        <Grid container spacing={0}>
                          <Grid xs={12}>
                            <div className="Innersection">
                              <h5 className="subTitle">
                                {item.section_name}
                                <div className="actionBtns">
                                  <Link
                                    className="delete_btn"
                                    sx={{
                                      textDecoration: "none",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <DeleteForeverIcon />
                                  </Link>
                                </div>
                              </h5>
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container spacing={4}>
                          <Droppable droppableId={index.toString()}>
                            {(provided, snapshot) => (
                              <Grid
                                sx={{ minHeight: 150, width: "100%" }}
                                container
                                spacing={2}
                                className="mx-0"
                                ref={provided.innerRef}
                              >
                                {item.fields.map((item, sub_index) => (
                                  <Draggable
                                    key={item.id}
                                    draggableId={item.id}
                                    index={sub_index}
                                  >
                                    {(provided, snapshot) => (
                                      <Grid
                                        sm={item.grid.sm}
                                        md={item.grid.md}
                                        lg={item.grid.lg}
                                        minWidth={200}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <div className="fieldBox">
                                          <div className="textField">
                                            <label>{item.title}</label>
                                            <p>{item.title}</p>
                                          </div>

                                          <Link
                                            onClick={() => {
                                              this.setState({
                                                toggleLock:
                                                  !this.state.toggleLock,
                                              });
                                            }}
                                          >
                                            {this.state.toggleLock == true ? (
                                              <LockOutlinedIcon className="closedLock" />
                                            ) : (
                                              <LockOpenOutlinedIcon />
                                            )}
                                          </Link>
                                          {/* <Button
                                            id="setting-button"
                                            aria-controls={
                                              this.open
                                                ? "basic-menu"
                                                : undefined
                                            }
                                            aria-haspopup="true"
                                            aria-expanded={
                                              this.open ? "true" : undefined
                                            }
                                            onClick={() => {
                                              this.setState({
                                                contactProperties: true,
                                              });
                                            }}
                                            className="settings">
                                            <SettingsOutlinedIcon />
                                          </Button> */}
                                          {/* <Menu
                                            // id="basic-menu"
                                            anchorEl={
                                              this.state.settingDropdown
                                            }
                                            open={this.open}
                                            onClose={this.closeSetting()}
                                            // MenuListProps={{
                                            //   'aria-labelledby': 'setting-button',
                                            // }}
                                          >
                                            <MenuItem
                                              onClick={this.closeSetting()}>
                                              Mark as Required
                                            </MenuItem>
                                            <MenuItem
                                              onClick={this.closeSetting()}>
                                              Edit Properties
                                            </MenuItem>
                                          </Menu> */}

                                          <Link
                                            className="settings"
                                            onClick={() => {
                                              this.setState({
                                                contactProperties: true,
                                              });
                                            }}
                                          >
                                            <SettingsOutlinedIcon />
                                          </Link>

                                          <Link
                                            className="delete"
                                            onClick={() => {
                                              this.delete_fields(
                                                index,
                                                sub_index
                                              );
                                            }}
                                          >
                                            <DeleteForeverOutlinedIcon />
                                          </Link>
                                        </div>
                                      </Grid>
                                    )}
                                  </Draggable>
                                ))}
                              </Grid>
                            )}
                          </Droppable>
                        </Grid>
                      </section>
                    ))}
                  </Box>
                </Grid>
              </DragDropContext>
            </>
          ) : null}
          {/* Fields in selected Module */}
          {this.state.productTabsStatus == "Fields" ? (
            <>
              <Grid xs={12} className="fieldsBox">
                <h5>All Fields</h5>
                <ul className="dataHeading">
                  <li>
                    Sr. no.
                    <button className="sorting-btn"></button>
                  </li>
                  <li>
                    Field Label
                    <button className="sorting-btn"></button>
                  </li>
                  <li>
                    Data Type
                    <button className="sorting-btn"></button>
                  </li>
                  <li>
                    Module
                    <button className="sorting-btn"></button>
                  </li>
                  <li>
                    Published in this form
                    <button className="sorting-btn"></button>
                  </li>
                </ul>
                {this.state.fields_data.map((data, index) => (
                  <ul className="dataLists">
                    <li>{data.srno}</li>
                    <li>{data.fieldname}</li>
                    <li>{data.datatype}</li>
                    <li>{data.module}</li>
                    {/* <li>{data.fieldcheck}</li> */}
                    <li>
                      <div className="Checkbox">
                        <input type="checkbox" name="check" />
                        <label className="employee"></label>
                      </div>
                    </li>
                  </ul>
                ))}
              </Grid>
            </>
          ) : null}
          {/* Summary of selected Module */}
          {this.state.productTabsStatus == "Summary" ? (
            <>
              <Grid xs={11}>
                <h5>Summary of the necessary information about this module.</h5>
              </Grid>
              <Grid xs={10} lg={8} className="summaryBox">
                <label>Primary</label>
                <ul>
                  <li>
                    <div>Module</div> : <div> Quotes </div>
                  </li>
                  <li>
                    <div>Displayed as</div> :{" "}
                    <div> To show Genereated Quotes</div>
                  </li>
                </ul>
              </Grid>
              <Grid xs={11} lg={8} className="summaryBox">
                <label>Customization</label>
                <ul>
                  <li>
                    <div>Module Permission</div> :{" "}
                    <div> Administrator, Standard </div>
                  </li>
                  <li>
                    <div>Fields</div> :
                    <div>
                      <ul>
                        <li>
                          <span>System</span> - <span> 50 </span>
                        </li>
                        <li>
                          <span>Custom</span> - <span> 0 out of 50 </span>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>Layout</div> : <div> Standard </div>
                  </li>
                </ul>
              </Grid>
            </>
          ) : null}
          {/* Stages of selected Module */}
          {this.state.productTabsStatus == "Stages" ? (
            <>
              <Grid xs={12} className="stagessection">
                <ul className="tableHeading">
                  <li>Client ID</li>
                  <li>
                    <button className="sorting-btn mr-10">
                      <img src="./images/sorting_btn.svg" alt="" />
                    </button>
                    Action
                  </li>
                </ul>
                {this.state.table_data.map((data, index) => (
                  <div className="contentarea">
                    <div className="tableSubHeading">
                      <p>
                        <Link
                          underline="none"
                          className="sourcing"
                          // onClick={() => {
                          //   let complete_data = this.state.table_data;
                          //   complete_data[index].open_status =
                          //     !complete_data[index].open_status;

                          //   this.setState({ table_data: complete_data });
                          // }}
                        >
                          {data.title}
                        </Link>
                      </p>
                      <p>
                        <>
                          <Link
                            underline="none"
                            className="addtaskaction mr-4"
                            onClick={() => {
                              this.setState({
                                addStatus: true,
                              });
                            }}
                          ></Link>
                          <Link
                            underline="none"
                            className="actiondelete mr-4"
                            onClick={() => {
                              this.setState({ deleteStatus: true });
                            }}
                          ></Link>
                          <Link
                            underline="none"
                            className="actionedit"
                            onClick={() => {
                              this.setState({
                                editStatus: true,
                              });
                            }}
                          ></Link>
                        </>
                      </p>
                    </div>
                    {
                      // data.open_status === true ?
                      data.data.map((value, index) => (
                        <ul className="innertable">
                          <li>
                            {" "}
                            <p> {value.name}</p>
                          </li>
                          <li>
                            <Link
                              underline="none"
                              className="actionedit mr-4"
                              onClick={() => {
                                this.setState({
                                  addStatus: true,
                                });
                              }}
                            ></Link>
                            <Link
                              underline="none"
                              className="actionremove"
                              onClick={() => {
                                this.setState({ deletePopup: true });
                              }}
                            ></Link>
                          </li>
                        </ul>
                      ))
                      // : null
                    }
                  </div>
                ))}
              </Grid>
            </>
          ) : null}
        </Grid>

        <Modal open={this.state.addStage} className="modalWrapper">
          <Box className="modalInner">
            <Grid container spacing={3}>
              <Grid xs={12}>
                <Link
                  className="close-button"
                  onClick={() => {
                    this.setState({ addStage: false });
                  }}
                />
                <h5 className="popup-heading">Add Stages</h5>
              </Grid>
              <p>{this.state.chooseColor}</p>
              <Grid xs={12}>
                <RKTextField
                  class_name="inputField"
                  title="Stage Name"
                  value={this.state.stageName}
                  attrName={"stageName"}
                  value_update={this.updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={12} className="ctaBtn" textAlign={"center"}>
                <Button variant="contained" className="submitBtn">
                  Save
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal open={this.state.addStatus} className="modalWrapper">
          <Box className="modalInner">
            <Grid container spacing={3}>
              <Grid xs={12}>
                <Link
                  className="close-button"
                  onClick={() => {
                    this.setState({ addStatus: false });
                  }}
                />
                <h5 className="popup-heading">Add Status</h5>
              </Grid>
              <Grid xs={12}>
                <RKTextField
                  class_name="inputField"
                  title="Status Name"
                  value={this.state.stageName}
                  attrName={"statusName"}
                  value_update={this.updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={12}>
                <RKTextField
                  class_name="inputField color-input"
                  title="Choose colour"
                  attrName={"chooseColor"}
                  value_update={this.updateMasterState}
                  warn_status={false}
                  type="color"
                  value={this.state.chooseColor}
                />
              </Grid>
              <Grid xs={12} className="ctaBtn" textAlign={"center"}>
                <Button variant="contained" className="submitBtn">
                  Save
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal open={this.state.editStatus} className="modalWrapper">
          <Box className="modalInner">
            <Grid container spacing={3}>
              <Grid xs={12}>
                <Link
                  className="close-button"
                  onClick={() => {
                    this.setState({ editStatus: false });
                  }}
                />
                <h5 className="popup-heading">Edit Status</h5>
              </Grid>
              <Grid xs={12}>
                <RKTextField
                  class_name="inputField"
                  title="Status Name"
                  value={this.state.stageName}
                  attrName={"statusName"}
                  value_update={this.updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={12} className="ctaBtn" textAlign={"center"}>
                <Button variant="contained" className="submitBtn">
                  Save
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        {/* <Modal open={this.state.deleteStatus} className="modalWrapper">
          <Box className="modalInner ">
            <Grid container spacing={1}>
              <Grid xs={12}>
                <Link
                  
                  className="close-button"
                  onClick={() => {
                    this.setState({ deleteStatus: false });
                  }}
                />
                <h5 className="popup-heading">Are you sure ?</h5>
              </Grid>
              <Grid xs={12}>
                <Link  className="md-link" underline="none">
                  You are about to delete this Stage.
                </Link>
              </Grid>
              <Grid xs={12} className="ctaBtn" textAlign={"center"}>
                <Button variant="contained" className="submitBtn">
                  Yes, Delete
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal> */}

        <Modal open={this.state.deleteStatus} className="modalWrapper">
          <>
            {this.state.deleteStatusStep === 1 ? (
              <Box className="modalInner deletepopup">
                <Grid container spacing={1}>
                  <Grid xs={12}>
                    <Link
                      className="close-button"
                      onClick={() => {
                        this.setState({ deleteStatus: false });
                      }}
                    />
                    <div className="img-prt">
                      <img
                        src="./images/deletepopup_deleteicon.svg"
                        alt=""
                        className="img"
                      />
                    </div>
                    <h5 className="popup-heading">
                      Are you sure you want
                      <br /> to delete "Sourcing" stage?
                    </h5>
                  </Grid>
                  <Grid xs={12}>
                    <p className="md-link mb-10">
                      You are about to delete 1 stage.
                    </p>
                  </Grid>
                  <Grid
                    xs={12}
                    className="ctaBtn"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button
                      variant="contained"
                      className="submitBtn"
                      onClick={() => {
                        this.setState({ deleteStatusStep: 2 });
                      }}
                    >
                      Yes, Delete
                    </Button>
                    <Button
                      variant="contained"
                      className="cancelBtn"
                      onClick={() => {
                        this.setState({ deleteStatus: false });
                      }}
                    >
                      cancel
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            ) : this.state.deleteStatusStep === 2 ? (
              <Box className="modalInner deletepopup">
                <Grid container spacing={1}>
                  <Grid xs={12}>
                    <Link
                      className="close-button"
                      onClick={() => {
                        this.setState({ deleteStatus: false });
                      }}
                    />
                    <div className="img-prt">
                      <img
                        src="./images/deletePopup_tickicon.svg"
                        alt=""
                        className="img"
                      />
                    </div>
                    <h5 className="popup-heading">Deleted Successfully!</h5>
                  </Grid>
                  <Grid xs={12}>
                    <p className="md-link mb-10">
                      Your Stage has been Deleted.
                    </p>
                  </Grid>
                  <Grid
                    xs={12}
                    className="ctaBtn"
                    style={{ textAlign: "center" }}
                  >
                    <Button
                      variant="contained"
                      className="submitBtn"
                      onClick={() => {
                        this.setState({
                          deleteStatus: false,
                          deleteStatusStep: 1,
                        });
                      }}
                    >
                      Okay
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            ) : null}
          </>
        </Modal>
      </Box>
    );
  }
}
